/* eslint-disable camelcase */
import { GqlDispensaries_Integrations, Maybe } from 'types/graphql';

export const isLeaflogixIntegrationEnabled = (
  menuType: 'med' | 'rec',
  leaflogixIntegration: Maybe<Array<Maybe<GqlDispensaries_Integrations>>>
): boolean => {
  const matchingIntegrationForMenuType = leaflogixIntegration?.find(
    (integration) => integration?.integrationType === menuType
  );
  if (matchingIntegrationForMenuType) {
    return true;
  }
  const unifiedIntegration = leaflogixIntegration?.find((integration) => !integration?.integrationType);
  if (unifiedIntegration) {
    return true;
  }
  return false;
};
